"use client";

// src/heading.tsx
import * as React from "react";
import { systemForwardRef } from "@stepstone-genesis/system";
import { Text } from "@stepstone-genesis/components-text";
var headingConfig = {
  heading4: {
    as: "h4"
  },
  heading3: {
    as: "h3"
  },
  heading2: {
    as: "h2"
  },
  heading1: {
    as: "h1"
  },
  jumbo: {
    as: "h1"
  },
  jumboPlus: {
    as: "h1"
  }
};
var Heading = systemForwardRef(function Heading2({ children, variant = "title", ...rest }, ref) {
  var _a;
  const tag = ((_a = headingConfig[variant]) == null ? void 0 : _a.as) || "div";
  return /* @__PURE__ */ React.createElement(
    Text,
    {
      as: tag,
      fontWeight: "fontWeightBold",
      fontFamily: "fontFamilyHeading",
      ref,
      role: "heading",
      variant,
      ...rest
    },
    children
  );
});
export {
  Heading
};
